/* ============================================
   HAPPYLAND CREATIVE
   All custom JavaScript lives here.
   On theme update: re-add this file to assets
   and re-add the script tag to theme.liquid.
   ============================================ */

// HAPPYLAND CREATIVE — CUSTOM
// Parallax: Hero section background images
(function () {
  const heroWrappers = document.querySelectorAll('.hero-wrapper');
  if (!heroWrappers.length) return;

  // Respect reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Desktop only — parallax on mobile is janky and barely visible
  if (window.innerWidth < 750) return;

  const imgs = document.querySelectorAll('.hero-wrapper .hero__media');
  if (!imgs.length) return;

  window.addEventListener('scroll', function () {
    const scrolled = window.scrollY;
    imgs.forEach(function (img) {
      img.style.transform = 'translateY(' + (scrolled * 0.25) + 'px)';
    });
  }, { passive: true });
})();

/* HAPPYLAND CREATIVE — CUSTOM: location locator (provider + inspector) */
(function () {
  var FIELD_CONFIG = {
    provider: {
      primary: 'practice_name',
      secondary: 'practitioner_name'
    },
    inspector: {
      primary: 'business_name',
      secondary: null
    }
  };

  var PAGE_SIZE = 20;

  function initLocator(root) {
    var type = root.dataset.type;
    var feed = root.dataset.feed;
    var requiresGate = root.dataset.requiresGate === 'true';
    var config = FIELD_CONFIG[type] || FIELD_CONFIG.provider;

    var searchInput = root.querySelector('.hc-locator__search');
    var countrySelect = root.querySelector('.hc-locator__country');
    var regionSelect = root.querySelector('.hc-locator__region');
    var countEl = root.querySelector('.hc-locator__count');
    var resultsEl = root.querySelector('.hc-locator__results');
    var loadMoreBtn = root.querySelector('.hc-locator__load-more');
    var emptyEl = root.querySelector('.hc-locator__empty');

    var allItems = [];
    var filteredItems = [];
    var visibleCount = PAGE_SIZE;
    var loaded = false;

    function fetchAllPages(page, acc) {
      if (page > 20) {
        // Safety net: something is wrong upstream if we get this far
        return Promise.resolve(acc);
      }
      return fetch(feed + '?page=' + page + '&_=' + Date.now())
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var combined = acc.concat(data.items || []);
          if (data.current_page < data.pages && (data.items || []).length > 0) {
            return fetchAllPages(page + 1, combined);
          }
          return combined;
        });
    }

    function populateFilterOptions() {
      var countries = [];
      var regions = [];
      allItems.forEach(function (item) {
        if (item.country && countries.indexOf(item.country) === -1) countries.push(item.country);
        if (item.state_region && regions.indexOf(item.state_region) === -1) regions.push(item.state_region);
      });
      countries.sort();
      regions.sort();
      countries.forEach(function (c) {
        var opt = document.createElement('option');
        opt.value = c;
        opt.textContent = c;
        countrySelect.appendChild(opt);
      });
      regions.forEach(function (r) {
        var opt = document.createElement('option');
        opt.value = r;
        opt.textContent = r;
        regionSelect.appendChild(opt);
      });
    }

    function matchesFilters(item) {
      var q = searchInput.value.trim().toLowerCase();
      var country = countrySelect.value;
      var region = regionSelect.value;

      if (country && item.country !== country) return false;
      if (region && item.state_region !== region) return false;

      if (q) {
        var haystack = [item[config.primary], config.secondary ? item[config.secondary] : '', item.city]
          .join(' ')
          .toLowerCase();
        if (haystack.indexOf(q) === -1) return false;
      }
      return true;
    }

    function cardHTML(item) {
      var addressParts = [item.address_1, item.address_2].filter(Boolean).join(', ');
      var cityLine = [item.city, item.state_region, item.zipcode].filter(Boolean).join(', ');
      var secondaryLine = config.secondary && item[config.secondary]
        ? '<p class="hc-locator__card-sub">' + escapeHTML(item[config.secondary]) + '</p>'
        : '';

      return (
        '<div class="hc-locator__card">' +
          '<p class="hc-locator__card-title">' + escapeHTML(item[config.primary] || '') + '</p>' +
          secondaryLine +
          '<p class="hc-locator__card-address">' +
            escapeHTML(addressParts) + (addressParts && cityLine ? '<br>' : '') + escapeHTML(cityLine) +
            (item.country ? '<br>' + escapeHTML(item.country) : '') +
          '</p>' +
          '<div class="hc-locator__card-contact">' +
            (item.telephone ? '<span><i class="hc-icon-phone" aria-hidden="true"></i>' + escapeHTML(item.telephone) + '</span>' : '') +
            (item.email ? '<span><a href="mailto:' + escapeAttr(item.email) + '">' + escapeHTML(item.email) + '</a></span>' : '') +
            (item.website ? '<span><a href="' + escapeAttr(normalizeUrl(item.website)) + '" target="_blank" rel="noopener">Visit website</a></span>' : '') +
          '</div>' +
        '</div>'
      );
    }

    function normalizeUrl(url) {
      if (!url) return '#';
      return /^https?:\/\//i.test(url) ? url : 'https://' + url;
    }

    function escapeHTML(str) {
      if (!str) return '';
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function escapeAttr(str) {
      return escapeHTML(str);
    }

    function render() {
      filteredItems = allItems.filter(matchesFilters);
      countEl.textContent = filteredItems.length.toLocaleString() + (type === 'provider' ? ' providers found' : ' inspectors found');

      var toShow = filteredItems.slice(0, visibleCount);
      resultsEl.innerHTML = toShow.map(cardHTML).join('');

      emptyEl.style.display = filteredItems.length === 0 ? 'block' : 'none';
      loadMoreBtn.style.display = filteredItems.length > visibleCount ? 'inline-block' : 'none';
    }

    function resetAndRender() {
      visibleCount = PAGE_SIZE;
      render();
    }

    function loadData() {
      if (loaded) return; // guard in case the event ever fires more than once
      loaded = true;
      root.hidden = false;

      countEl.textContent = 'Loading…';
      fetchAllPages(1, [])
        .then(function (items) {
          allItems = items;
          populateFilterOptions();
          render();
        })
        .catch(function () {
          countEl.textContent = '';
          emptyEl.textContent = 'Unable to load locations right now. Please try again later.';
          emptyEl.style.display = 'block';
        });
    }

var debounceTimer;
  searchInput.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(resetAndRender, 200);
  });
  countrySelect.addEventListener('change', resetAndRender);
  regionSelect.addEventListener('change', resetAndRender);
  loadMoreBtn.addEventListener('click', function () {
    visibleCount += PAGE_SIZE;
    render();
  });

  if (requiresGate) {
    document.addEventListener('hc:accession-verified', loadData);
  } else {
    loadData();
  }
}

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.hc-locator').forEach(initLocator);
  });
})();

// standalone accession-gate section
(function () {
  document.querySelectorAll('.accession-gate__form').forEach(function (form) {
    const btn = form.querySelector('.accession-verify-btn');
    const input = form.querySelector('.accession-gate__input');
    if (!btn || !input) return;

    btn.addEventListener('click', function () {
      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }
      const originalText = btn.textContent;
      btn.textContent = 'Checking...';
      btn.disabled = true;
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent('hc:accession-verified'));
      }, 1200);
    });
  });
})();

// Accession number gate: disable Add to Cart until 10-digit value entered
(function () {
  const field = document.querySelector('[data-accession-gate]');
  if (!field) return;

  function getAddToCartButtons() {
    return document.querySelectorAll('button[name="add"], .add-to-cart-button, [ref="addToCartButton"]');
  }

  function validate() {
    const isValid = /^[0-9]{10}$/.test(field.value);
    getAddToCartButtons().forEach(btn => {
      btn.disabled = !isValid;
      btn.classList.toggle('accession-gate-disabled', !isValid);
    });
  }

  field.addEventListener('input', validate);
  document.addEventListener('DOMContentLoaded', validate);
  validate();
})();

/* Force-decode mega menu featured product images on page load */
document.addEventListener('DOMContentLoaded', function () {
  var megaMenuImages = document.querySelectorAll('.mega-menu__content-list--products img');

  megaMenuImages.forEach(function (img) {
    if (img.decode) {
      img.decode().catch(function () {
        // Decode can fail/abort harmlessly if the image changes source; safe to ignore
      });
    }
  });
});

// Request Provider Pricing popup (HubSpot form in a <dialog>)
(function () {
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hc-open-pricing]')) {
      const modal = document.getElementById('hc-pricing-modal');
      if (modal && typeof modal.showModal === 'function') modal.showModal();
      return;
    }
    if (e.target.closest('[data-hc-close-pricing]')) {
      const modal = e.target.closest('dialog');
      if (modal) modal.close();
      return;
    }
    // Click on the dark backdrop closes it
    if (e.target.matches('dialog.hc-pricing-modal')) {
      e.target.close();
    }
  });
})();

// Practitioner / patient audience popup + practitioner redirects + practitioner banner
// Markup lives in a Custom Liquid section in the Footer group.
(function () {
  const root = document.getElementById('hc-audience');
  if (!root) return;

  const KEY = 'hc_audience';
  const DISMISS_KEY = 'hc_audience_dismissed';
  const MAX_AGE = 30 * 24 * 60 * 60 * 1000; // 30 days

  const modal = document.getElementById('hc-audience-modal');
  const banner = root.querySelector('[data-hc-audience-reset-wrap]');
  const providerUrl = root.dataset.providerUrl || '';
  const providersPage = root.dataset.providersPage || '/pages/for-providers';
  const isHome = root.dataset.pageType === 'index';
  const skipPopup = root.dataset.skip === 'true';

  // Move the practitioner banner to the very top of the page
  if (banner) document.body.prepend(banner);

  function getChoice() {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY));
      if (!saved || Date.now() - saved.time > MAX_AGE) return null;
      return saved.value;
    } catch (e) { return null; }
  }
  function setChoice(value) {
    try { localStorage.setItem(KEY, JSON.stringify({ value: value, time: Date.now() })); } catch (e) {}
  }
  function isDismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  }
  function setDismissed() {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }
  function showBanner(show) {
    if (banner) banner.hidden = !show;
  }

  const choice = getChoice();

  // Returning practitioner on a D2C product that has a provider version
  if (choice === 'practitioner' && providerUrl) {
    window.location.replace(providerUrl);
    return;
  }

  showBanner(choice === 'practitioner');

  // First visit: ask (unless this page is already for practitioners,
  // or they closed the popup earlier in this visit)
  if (!choice && !skipPopup && !isDismissed() && modal && typeof modal.showModal === 'function') {
    modal.showModal();
  }

  if (modal) {
    // Esc key closes without choosing: don't ask again this visit
    modal.addEventListener('cancel', setDismissed);
  }

  // Popup buttons + backdrop
  root.addEventListener('click', function (e) {
    const pick = e.target.closest('[data-hc-audience]');
    if (pick) {
      const value = pick.dataset.hcAudience;
      setChoice(value);
      if (value === 'practitioner') {
        if (providerUrl) { window.location.replace(providerUrl); return; }
        if (isHome) { window.location.href = providersPage; return; }
        showBanner(true);
      }
      modal.close();
      return;
    }

    // Click on the dark backdrop: close without choosing
    if (e.target === modal) {
      setDismissed();
      modal.close();
    }
  });

  // "Switch to patient view" in the banner
  if (banner) {
    banner.addEventListener('click', function (e) {
      if (e.target.closest('[data-hc-audience-reset]')) {
        e.preventDefault();
        setChoice('patient');
        showBanner(false);
      }
    });
  }
})();